import React, { FC, createContext, useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export type GetAssetFunction = (asset: string) => {
  url: string;
  path: string;
  field?: unknown;
  fileObj: File;
};

export const AssetContext = createContext<GetAssetFunction | null>(null);

interface Props {
  src: string;
  alt: string;
  loading?: 'lazy' | 'eager';
}

export const NeltifyImage: FC<Props> = ({ src, alt, loading = 'lazy', ...rest }) => {
  const getAsset = useContext(AssetContext);

  // Use eager loading for above-the-fold images, LazyLoadImage for others
  if (loading === 'eager') {
    if (!getAsset) return <img src={src.toString()} alt={alt} {...rest} />;
    return <img src={getAsset(src).toString()} alt={alt} {...rest} />;
  }

  if (!getAsset) {
    return <LazyLoadImage src={src.toString()} alt={alt} {...rest} />;
  }

  return <LazyLoadImage src={getAsset(src).toString()} alt={alt} {...rest} />;
};
